import "./area-of-practise-header.styles.css";

const AreaOfPractiseHeader = (props) => (
  <div className="area-of-practise-header">
    <p className="area-of-practise-header-title">{props.title}</p>
  </div>
);

export default AreaOfPractiseHeader;
